import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import RegisterChangeRepository from '../../../../repositories/RegisterChange';
import RegisterChangeDataRepository from '../../../../../data/repositories/RegisterChangeDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_CHANGE_REQUEST });
    XCheckpointManager.registerStart('Cambio de modalidad register');
    const registerChangeRepository: RegisterChangeRepository =
      new RegisterChangeDataRepository();
    const registerChangeResponse = yield call(
      registerChangeRepository.register,
      action.procedureId,
      action.newModality,
      action.newModalityName,
      action.newPeriod,
      action.newCampus,
      action.plan,
      action.career,
      action.period,
      action.shift || '',
      action.shiftDesc || ''
    );
    // if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!registerChangeResponse) {
      yield put({
        type: Types.REGISTER_CHANGE_FAILURE,
        error: 'No se pudo leer los datos del trámite.'
      });
      return;
    }

    yield put({
      type: Types.REGISTER_CHANGE_SUCCESS,
      requestId: registerChangeResponse.requestId
    });
    XCheckpointManager.registerEnd('Cambio de modalidad register');
  } catch (error) {
    yield put({
      type: Types.REGISTER_CHANGE_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos del trámite solicitado.'
    });
  }
}
